import { render } from "./AnotherDriverPage.vue?vue&type=template&id=67f2e5c5&scoped=true"
import script from "./AnotherDriverPage.vue?vue&type=script&lang=js"
export * from "./AnotherDriverPage.vue?vue&type=script&lang=js"

import "./AnotherDriverPage.vue?vue&type=style&index=0&id=67f2e5c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f2e5c5"]])

export default __exports__